import React from 'react';
import { Navigate, Route, Routes, useLocation, Outlet } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core/styles';

import CompleteContact from '@bizapp-lp/home/pages/CompleteContact';
import Invalid from '@bizapp-lp/home/pages/Invalid';
import TermsArchive06 from '@bizapp-lp/home/pages/terms/0620210802';
import TermsArchive07 from '@bizapp-lp/home/pages/terms/0720211223';
import TermsArchive08 from '@bizapp-lp/home/pages/terms/0820220307';
import TermsArchive09 from '@bizapp-lp/home/pages/terms/0920220425';
import TermsArchive10 from '@bizapp-lp/home/pages/terms/1020230401';

import Sitemap from './components/pages/internal/Sitemap';

import { theme } from './styles/theme';

interface RedirectProps {
  to?: string;
}

const Redirect: React.FC<RedirectProps> = ({ to }) => {
  React.useEffect(() => {
    window.location.href = to ?? 'https://www.worksap.co.jp/saas';
  }, [to]);
  return <></>;
};

const App: React.FC = () => {
  const { hash, pathname } = useLocation();

  React.useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [hash, pathname]);

  return (
    <ThemeProvider theme={theme}>
      <Routes>
        <Route
          path="/contact"
          element={<Redirect to="https://www.worksap.co.jp/contact/" />}
        />
        <Route
          path="/complete-contact"
          element={<CompleteContact isAllowedDirectAccess />}
        />
        <Route
          path="/law"
          element={
            <>
              <Outlet />
            </>
          }
        >
          <Route
            path="/"
            element={<Redirect to="https://www.worksap.co.jp/transaction/" />}
          />
          <Route
            path="/:from"
            element={<Redirect to="https://www.worksap.co.jp/transaction/" />}
          />
        </Route>
        <Route path="/invalid" element={<Invalid />} />
        <Route
          path="/privacy"
          element={
            <>
              <Outlet />
            </>
          }
        >
          <Route
            path="/"
            element={
              <Redirect to="https://www.worksap.co.jp/personal-information-handling/" />
            }
          />
          <Route
            path="/:from"
            element={
              <Redirect to="https://www.worksap.co.jp/personal-information-handling/" />
            }
          />
        </Route>
        <Route
          path="/terms"
          element={
            <>
              <Outlet />
            </>
          }
        >
          <Route
            path="/"
            element={
              <Redirect to="https://www.worksap.co.jp/saas/terms/spec/" />
            }
          />
          <Route
            path="/:from"
            element={
              <Redirect to="https://www.worksap.co.jp/saas/terms/spec/" />
            }
          />
        </Route>
        <Route
          path="/terms-archive"
          element={
            <>
              <Outlet />
            </>
          }
        >
          <Route path="/06-20210802" element={<TermsArchive06 />} />
          <Route path="/07-20211223" element={<TermsArchive07 />} />
          <Route path="/08-20220307" element={<TermsArchive08 />} />
          <Route path="/09-20220425" element={<TermsArchive09 />} />
          <Route path="/10-20230401" element={<TermsArchive10 />} />
          <Route
            path="/"
            element={
              <Redirect to="https://www.worksap.co.jp/saas/terms/spec/" />
            }
          />
        </Route>
        <Route path="/internal/sitemap" element={<Sitemap />} />
        <Route
          path="/internal/*"
          element={<Navigate to="/internal/sitemap" replace />}
        />
        <Route path="*" element={<Redirect />} />
      </Routes>
    </ThemeProvider>
  );
};

export default App;
